import React from 'react';

import { SVGComponentProps } from './svg.types';

const FullScreenSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.24687 0.75C4.24687 0.948912 4.16786 1.13968 4.02721 1.28033C3.88655 1.42098 3.69579 1.5 3.49687 1.5H1.5V3.49687C1.5 3.69579 1.42098 3.88655 1.28033 4.02721C1.13968 4.16786 0.948912 4.24687 0.75 4.24687C0.551088 4.24687 0.360322 4.16786 0.21967 4.02721C0.0790176 3.88655 0 3.69579 0 3.49687V0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790176 0.551088 0 0.75 0L3.49687 0C3.69579 0 3.88655 0.0790176 4.02721 0.21967C4.16786 0.360322 4.24687 0.551088 4.24687 0.75V0.75ZM3.49687 10.5H1.5V8.50312C1.5 8.30421 1.42098 8.11345 1.28033 7.97279C1.13968 7.83214 0.948912 7.75312 0.75 7.75312C0.551088 7.75312 0.360322 7.83214 0.21967 7.97279C0.0790176 8.11345 0 8.30421 0 8.50312L0 11.25C0 11.4489 0.0790176 11.6397 0.21967 11.7803C0.360322 11.921 0.551088 12 0.75 12H3.49687C3.69579 12 3.88655 11.921 4.02721 11.7803C4.16786 11.6397 4.24687 11.4489 4.24687 11.25C4.24687 11.0511 4.16786 10.8603 4.02721 10.7197C3.88655 10.579 3.69579 10.5 3.49687 10.5ZM11.25 7.75312C11.0511 7.75312 10.8603 7.83214 10.7197 7.97279C10.579 8.11345 10.5 8.30421 10.5 8.50312V10.5H8.50312C8.30421 10.5 8.11345 10.579 7.97279 10.7197C7.83214 10.8603 7.75312 11.0511 7.75312 11.25C7.75312 11.4489 7.83214 11.6397 7.97279 11.7803C8.11345 11.921 8.30421 12 8.50312 12H11.25C11.4489 12 11.6397 11.921 11.7803 11.7803C11.921 11.6397 12 11.4489 12 11.25V8.50312C12 8.30421 11.921 8.11345 11.7803 7.97279C11.6397 7.83214 11.4489 7.75312 11.25 7.75312ZM11.25 0H8.50312C8.30421 0 8.11345 0.0790176 7.97279 0.21967C7.83214 0.360322 7.75312 0.551088 7.75312 0.75C7.75312 0.948912 7.83214 1.13968 7.97279 1.28033C8.11345 1.42098 8.30421 1.5 8.50312 1.5H10.5V3.49687C10.5 3.69579 10.579 3.88655 10.7197 4.02721C10.8603 4.16786 11.0511 4.24687 11.25 4.24687C11.4489 4.24687 11.6397 4.16786 11.7803 4.02721C11.921 3.88655 12 3.69579 12 3.49687V0.75C12 0.551088 11.921 0.360322 11.7803 0.21967C11.6397 0.0790176 11.4489 0 11.25 0V0Z"
          fill="#878A92"
        />
      </svg>
    </span>
  );
};

export default FullScreenSVG;
